// extracted by mini-css-extract-plugin
export default {"responsive-row":"Delivery_responsive-row__GFl53"};